import {Formik} from 'formik';
import React, {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {presetGetter} from '../../services/env/siteSettings/fonts/fonts';
import {noops} from '../../services/utils/noop';
import {validateEmailField} from '../../services/utils/validateEmailField/validateEmailField';
import {Button} from '../ui/Button/Button';
import {TextInput} from '../ui/TextInput/TextInput';
import styles from './EmailForm.scss';

interface IProps {
  initialEmail?: string;
  submitButtonText: ReactNode;
  onSubmit: (params: {email: string}) => void;
  onValidationFailed: (params: {errorMsg: string}) => void;
}

export const EmailForm: React.FunctionComponent<IProps> = ({
  submitButtonText,
  onSubmit,
  onValidationFailed = noops,
  initialEmail,
}) => {
  const {t} = useTranslation();
  return (
    <Formik
      initialValues={{email: initialEmail}}
      onSubmit={(values) => onSubmit({email: values.email!})}
      validate={validateEmailField(t)}
    >
      {({handleSubmit, values}) => (
        <form
          onSubmit={(...args) => {
            const {email} = validateEmailField(t)(values);
            if (email) {
              onValidationFailed({errorMsg: email});
            }
            return handleSubmit(...args);
          }}
          className={styles.form}
          data-hook="subscribeForm"
          noValidate
        >
          <TextInput
            data-hook="email-input"
            name="email"
            type="email"
            required
            autoFocus
            aria-label={t('mgw.emailAddress')}
            placeholder={t('mgw.emailAddress')}
          />
          <Button type="submit" theme="big" dataHook="email-submit">
            {submitButtonText}
          </Button>
        </form>
      )}
    </Formik>
  );
};
